// Ouvre le drawer cart de façon universelle
function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer, .cart-drawer');
  if (!drawer) return;

  // Méthode des thèmes OS2.0 récents
  if (typeof drawer.open === 'function') {
    try { drawer.open(); return; } catch(e){}
  }

  // Fallback : classe d'ouverture
  drawer.classList.add('active', 'is-open', 'open');
  document.documentElement.classList.add('no-scroll', 'overflow-hidden');
}

// Intercepte TOUTES les soumissions vers /cart/add
document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form.matches('form[action*="/cart/add"]')) return;

  // Empêche la soumission classique
  e.preventDefault();

  const fd = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: fd,
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  })
  .then(res => {
    // Si erreur Shopify (ex: stock), on laisse ton thème gérer l’affichage d’erreur
    if (!res.ok) return res.json().then(err => { throw err; });
    return res.json();
  })
  .then(() => {
    // Optionnel : rafraîchir le mini-panier si ton thème écoute cet évènement
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // On ouvre le drawer
    openCartDrawer();

    // Optionnel : MAJ du compteur panier si présent
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.querySelector('[data-cart-count], .cart-count-bubble, .cart-count');
        if (badge) {
          const total = cart.item_count || 0;
          if ('textContent' in badge) badge.textContent = total;
          badge.setAttribute && badge.setAttribute('data-cart-count', total);
        }
      })
      .catch(() => {});
  })
  .catch(err => {
    console.warn('Add to cart error', err);
    // En cas d’erreur, on n’ouvre pas le drawer.
  });
}, true);

// Sécurité : si un bouton ajoute via JS (sans submit),
// on écoute aussi le clic sur le bouton name="add"
document.addEventListener('click', function(e){
  const btn = e.target.closest('button[name="add"], [data-add-to-cart], .product-form__submit');
  if (!btn) return;
  // Si le thème fait un POST AJAX lui-même, on ouvrira quand même le drawer
  // après une courte latence.
  setTimeout(() => openCartDrawer(), 600);
}, true);
